import TeamBuilding1 from "./../../../assets/teamBuilding/1.jpg";
import TeamBuilding2 from "./../../../assets/teamBuilding/2.jpg";
import TeamBuilding3 from "./../../../assets/teamBuilding/3.jpg";
import TeamBuilding4 from "./../../../assets/teamBuilding/4.jpg";
import TeamBuilding5 from "./../../../assets/teamBuilding/5.jpg";
import TeamBuilding6 from "./../../../assets/teamBuilding/6.jpg";
import TeamBuilding7 from "./../../../assets/teamBuilding/7.jpg";
import TeamBuilding8 from "./../../../assets/teamBuilding/8.jpg";
import TeamBuilding9 from "./../../../assets/teamBuilding/9.jpg";
import TeamBuilding10 from "./../../../assets/teamBuilding/10.jpg";

import Firing1 from "./../../../assets/firing/1.jpg";
import Firing2 from "./../../../assets/firing/2.jpg";
import Firing3 from "./../../../assets/firing/3.jpg";
import Firing4 from "./../../../assets/firing/4.jpg";
import Firing5 from "./../../../assets/firing/5.jpg";
import Firing6 from "./../../../assets/firing/6.jpg";
import Firing7 from "./../../../assets/firing/7.jpg";
import Firing8 from "./../../../assets/firing/8.jpg";
import Firing9 from "./../../../assets/firing/9.jpg";
import Firing10 from "./../../../assets/firing/10.jpg";
import Firing11 from "./../../../assets/firing/11.jpg";

export const teamImages = [
  TeamBuilding1,
  TeamBuilding2,
  TeamBuilding3,
  TeamBuilding4,
  TeamBuilding5,
  TeamBuilding6,
  TeamBuilding7,
  TeamBuilding8,
  TeamBuilding9,
  TeamBuilding10,
];

export const firingImages = [
  Firing1,
  Firing2,
  Firing3,
  Firing4,
  Firing5,
  Firing6,
  Firing7,
  Firing8,
  Firing9,
  Firing10,
  Firing11,
];
